
import Vue from 'vue'
import CreditNoteTransformer from '@/transformers/taxReceipt/creditNote'
import errorHandler from '@/utils/errorHandler'
import { objectToForm } from '@/utils'

const sendTransformer = ({xml, pdf }) => {
  return objectToForm({
    xml_file: xml,
    pdf_file: pdf
  })
}

const config = { headers: {'Content-Type': 'multipart/form-data' }}

export default (creditNote) =>
  errorHandler(Vue.$http.post('taxreceipt/creditnotes/', sendTransformer(creditNote), config))
    .then(response => CreditNoteTransformer.fetch(response.data))


// WEBPACK FOOTER //
// ./src/services/taxReceipt/createCreditNote.js